import CloseIcon from '@mui/icons-material/Close';
import { Alert, Button, Checkbox, createTheme, FormHelperText, InputLabel, MenuItem, Select, Stack, TextField, ThemeProvider, Typography } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { styles } from '../../style/style';

const theme = createTheme({
    //sets color of text in dropdown/selectors 
    palette: {
        primary: {
            main: '#00439D',
        },
        secondary: {
            main: '#11cb5f',
        },
    },
});

export function AdvancedSearchAppName() {
    return (
        <>
            <Typography id="advancedSeacrhTitle" variant="h2" sx={styles.h2PageTitle}><strong><FormattedMessage id='advancedsearchcomponents.appname' defaultMessage='Advanced Search' /></strong></Typography>
            <Grid container sx={{ pt: '2%', pl: '3%' }}>
                <Typography id="advancedSearchSearchCriteriaTitle" variant="h3" sx={styles.h3SectionTitle}><FormattedMessage id='advancedsearchcomponents.searchcriteria' defaultMessage='Search Criteria' /></Typography>
            </Grid>
        </>
    )
}

export function PrimaryFanLabel(props) {
    return (
        <>
            <Typography variant="caption" sx={styles.pBodyText}>{props.primaryFan}</Typography>
        </>
    )
}
export function PrimaryFanText(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id={props.id}
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "advancedsearchcomponents.primaryfan", defaultMessage: "Primary FAN" })}
                onChange={props.onChangePrimaryFan} />
        </>
    )
}

export function EndUserText(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id={props.id}
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "advancedsearchcomponents.enduserfan", defaultMessage: "End User FAN" })}
                onChange={props.onChangeEndUserFan} />
        </>
    )
}

export function ChargeToBacLabel(props) {
    return (
        <>
            <Typography variant="body1" sx={styles.pBodyText}>
                <strong><FormattedMessage id='advancedsearchcomponents.chargetobac' defaultMessage='Charge to Business Associate Code (BAC)' /></strong>
            </Typography>
            <Typography variant="caption" sx={styles.pBodyText}>{props.bacNumber}</Typography>
        </>
    )
}

export function ChargeToBacText(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id={props.id}
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "advancedsearchcomponents.chargetobac", defaultMessage: "Charge to BAC" })}
                onChange={props.onChangeChargeToBac} />
        </>
    )
}

export function ShipToBac(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id={props.id}
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "advancedsearchcomponents.shiptobac", defaultMessage: "Ship-To BAC" })}
                onChange={props.onChangeShipBac} />
        </>
    )
}

export function ChargeToBfc(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id="chargeToBfc"
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "advancedsearchcomponents.chargetobfc", defaultMessage: "Charge-To BFC" })}
                onChange={props.onChangeChargeToBfc} />
        </>
    )
}


export function AllocationGroupText(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id="allocationGroupText"
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "advancedsearchcomponents.allocationGroup", defaultMessage: "Allocation Group" })}
                onChange={props.onChangeAllocationGroup} />
        </>
    )
}


export function DanText(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id="danText"
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "advancedsearchcomponents.dan", defaultMessage: "DAN" })}
                onChange={props.onChangeDan} />
        </>
    )
}

export function OrderNumber(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id="orderNumber"
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "orderRequestList.orderNumber", defaultMessage: "Order Number" })}
                onChange={props.onChangeOrderNum} />
        </>
    )
}

export function PurchaseNumber(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id="purchaseNumber"
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "orderdetailcomponents.purchaseOrderNumber", defaultMessage: "Purchase Number" })}
                onChange={props.onChangePurchaseNum} />
        </>
    )
}


export function Division(props) {
    const intl = useIntl();
    return (
        <>
            <FormControl aria-labelledby='Division' variant='filled' sx={styles.advancedSearchSelect}>
                <ThemeProvider theme={theme}>
                    <InputLabel><FormattedMessage id="advancedsearchcomponents.division" defaultMessage="Division" /></InputLabel>
                </ThemeProvider>
                <Select
                    variant="filled"
                    value={props.value}
                    labelId="division"
                    id="divisionDropdown"
                    onChange={props.handleDivChange}
                    MenuProps={{ disableScrollLock: false }}
                >
                    <MenuItem key='All' value='All'>All</MenuItem>
                    {props.options.map(option => {
                        return (
                            <MenuItem key={option.divisionName} value={option.divisionName}>{option.divisionName}</MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </>
    )
}

export function Model(props) {
    var sellingCode = props.selectedDivision.split(' ')[0];
    let distinctModelList = [];
    let renderedMenuItem;

    props.distinctModel.map(model => {
        distinctModelList.push(model)
    })

    if (sellingCode === 'All') {
        renderedMenuItem = distinctModelList.map(option => {
            return (
                <MenuItem key={option} value={option}>
                    {option}
                </MenuItem>
            )
        })
    } else {
        renderedMenuItem = props.options.filter(option => option.sellingSourceCode.includes(sellingCode)).map(
            filteredData => (
                <MenuItem key={filteredData.modelDesgntr} value={filteredData.modelDesgntr}>{filteredData.modelDesgntr}</MenuItem>
            )
        )

    }

    return (
        <>
            <FormControl variant='filled' sx={styles.advancedSearchSelect}>
            <ThemeProvider theme={theme}>
                <InputLabel ><FormattedMessage id="advancedsearchcomponents.model" defaultMessage="Model" /></InputLabel>
                </ThemeProvider>
                <Select
                    id="modelDropDown"
                    variant='filled'
                    labelId='model'
                    value={props.value}
                    disabled={props.selectedModelYr === '' || props.selectedDivision === '' || renderedMenuItem.length == 0}
                    onChange={props.handleModelChange}
                    MenuProps={{ disableScrollLock: false }}
                >
                    {renderedMenuItem}

                </Select>
                <FormControl sx={{ fontStyle: 'italic' }}>{props.selectedModelYr !== '' && props.selectedDivision !== '' && renderedMenuItem.length == 0 ? <FormattedMessage id="advancedsearchcomponents.noModelsFound" defaultMessage="No models found for this criteria" /> : ''}</FormControl>
            </FormControl>
        </>
    )
}

export function RequestTargetFrom(props) {
    const intl = useIntl();
    return (
        <>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={props.calendarLocale}>
                    <Stack spacing={3}>
                        <DatePicker
                            id="requestTargetFromDate"
                            value={props.requestTargetFrom}
                            label={intl.formatMessage({ id: "advancedsearchcomponents.from", defaultMessage: "From" })}
                            onChange={(newValue) => {
                                let onlyDate = newValue.$d.toISOString()
                                props.handleRequestTargetFrom(onlyDate);
                            }}
                            maxDate={props.disableToDate}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        {...params}

                                        sx={styles.orderSummaryTextField}
                                        variant='filled'

                                        inputProps={{
                                            ...params.inputProps,
                                            readOnly: true,
                                            placeholder: intl.formatMessage({ id: "advancedsearchcomponents.calendarinputformat", defaultMessage: "MM/DD/YYYY" })
                                        }}
                                    />
                                )
                            }}

                        />
                    </Stack>
                </LocalizationProvider>
            </ThemeProvider>
        </>
    )
}

export function RequestTargetTo(props) {
    const intl = useIntl();
    return (
        <>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={props.calendarLocale}>
                    <Stack spacing={3}>
                        <DatePicker
                            id="requestTargetTo"
                            value={props.requestTargetTo}
                            label={intl.formatMessage({ id: "advancedsearchcomponents.to", defaultMessage: "To" })}
                            onChange={(newValue) => {
                                let onlyDate = newValue.$d.toISOString()
                                props.handleRequestTargetTo(onlyDate);
                            }}
                            minDate={props.disableFromDate}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        {...params}

                                        sx={styles.orderSummaryTextField}
                                        variant='filled'

                                        inputProps={{
                                            ...params.inputProps,
                                            readOnly: true,
                                            placeholder: intl.formatMessage({ id: "advancedsearchcomponents.calendarinputformat", defaultMessage: "MM/DD/YYYY" })
                                        }}
                                    />
                                )
                            }}

                        />
                    </Stack>
                </LocalizationProvider>
            </ThemeProvider>
        </>
    )
}

export function ActualTargetFrom(props) {
    const intl = useIntl();
    return (
        <>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={props.calendarLocale}>
                    <Stack spacing={3}>
                        <DatePicker
                            id="actualTargetFrom"
                            value={props.actualTargetFrom}
                            label={intl.formatMessage({ id: "advancedsearchcomponents.from", defaultMessage: "From" })}
                            onChange={(newValue) => {
                                //console(newValue)
                                //console(newValue.$d.toISOString())
                                let onlyDate = newValue.$d.toISOString()
                                props.handleActualTargetFrom(onlyDate);
                            }}
                            maxDate={props.disableToDate}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        {...params}

                                        sx={styles.orderSummaryTextField}
                                        variant='filled'

                                        inputProps={{
                                            ...params.inputProps,
                                            readOnly: true,
                                            placeholder: intl.formatMessage({ id: "advancedsearchcomponents.calendarinputformat", defaultMessage: "MM/DD/YYYY" })
                                        }}
                                    />
                                )
                            }}
                        />
                    </Stack>
                </LocalizationProvider>
            </ThemeProvider>
        </>
    )
}

export function ActualTargetTo(props) {
    const intl = useIntl();
    return (
        <>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={props.calendarLocale}>
                    <Stack spacing={3}>
                        <DatePicker
                            id="actualTargetTo"
                            value={props.actualTargetTo}
                            label={intl.formatMessage({ id: "advancedsearchcomponents.to", defaultMessage: "To" })}
                            onChange={(newValue) => {
                                let onlyDate = newValue.$d.toISOString()
                                props.handleActualTargetTo(onlyDate);
                            }}
                            minDate={props.disableFromDate}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        {...params}

                                        sx={styles.orderSummaryTextField}
                                        variant='filled'

                                        inputProps={{
                                            ...params.inputProps,
                                            readOnly: true,
                                            placeholder: intl.formatMessage({ id: "advancedsearchcomponents.calendarinputformat", defaultMessage: "MM/DD/YYYY" })
                                        }}
                                    />
                                )
                            }}
                        />
                    </Stack>
                </LocalizationProvider>
            </ThemeProvider>
        </>
    )
}

export function ModelYear(props) {
    const intl = useIntl();
    return (
        <>
            <FormControl variant='filled' sx={styles.orderSummarySelect}>
                <ThemeProvider theme={theme}>
                    <InputLabel><FormattedMessage aria-label="modelYear" id="advancedsearchcomponents.modelyear" defaultMessage="Model" /></InputLabel>
                </ThemeProvider>
                <Select
                    id="modelYearDropdown"
                    variant='filled'
                    aria-checked="true"
                    aria-label="ModelYear"
                    aria-labelledby='ModelYear'
                    labelId="modelYear"
                    multiple
                    value={props.value}
                    onChange={props.handleChange}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={{ disableScrollLock: false }}
                >
                    <MenuItem id={"ALL"} key={"ALL"} value={"ALL"} aria-selected="true">
                        <ListItemText primary={"All"} />
                    </MenuItem>
                    {props.options.map((option) => (
                        <MenuItem id={option} key={option} value={option} aria-selected="true">
                            <Checkbox aria-label="modelYear" aria-labelledby='ModelYear' checked={props.value.indexOf(option) > -1}/>
                            <ListItemText primary={option} />
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText hidden={props.modelYearRequired === ""} error>{props.modelYearRequired}</FormHelperText>
            </FormControl>
        </>
    )
}

export function AdvancedSearchAlert(props) {
    const [open, setOpen] = useState(true);
    return (
        <>
            <Collapse sx={{ ml: 20, mr: 20, fontSize: '30px' }} in={open}>
                <Alert severity="error" sx={{ fontSize: '30px' }}
                    action={
                        <IconButton
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    }
                >
                    {props.errorMessage}
                </Alert>
            </Collapse>
        </>
    )
}


export function EventCodeFrom(props) {

    let defaultEventCodeFromValue;

    if (props.value === '') {
        defaultEventCodeFromValue = props.defaultEventFrom
    }
    else {
        defaultEventCodeFromValue = props.value
    }

    return (
        <>
            <FormControl variant='filled' sx={styles.advancedSearchSelect}>
                <ThemeProvider theme={theme}>
                    <InputLabel><FormattedMessage id="advancedsearchcomponents.eventcodefrom" defaultMessage="Event Code : From" /></InputLabel>
                </ThemeProvider>
                <Select
                    id="eventCodeFrom"
                    variant='filled'
                    labelId='eventCodeFrom'
                    value={defaultEventCodeFromValue}
                    onChange={props.handleEventCodeFrom}
                    MenuProps={{ disableScrollLock: false }}
                >
                    {props.options.map((option, index) => {
                        return (
                            <MenuItem key={index} value={option.vehEventCodes}>

                                {/* {option.vehEventCodes.split(' / ')[0]} / <FormattedMessage
                                    id={`eventcode.${option.vehEventCodes.split(' ')[0]}`}
                                    defaultMessage={option.vehEventCodes} /> */}

                                {option.vehEventCodes} / <FormattedMessage
                                    id={`eventcode.${option.vehEventCodes}`}
                                    defaultMessage={option.vehEventCodes} />

                                {/*  {option.vehEventCodes} */}
                            </MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </>
    )
}


export function EventCodeTo(props) {
    let defaultEventCodeToValue;

    if (props.value === '') {
        defaultEventCodeToValue = props.defaultEventTo
    }
    else {
        defaultEventCodeToValue = props.value
    }

    return (
        <>
            <FormControl variant='filled' sx={styles.advancedSearchSelect}>
                <ThemeProvider theme={theme}>
                    <InputLabel><FormattedMessage id="advancedsearchcomponents.eventcodeto" defaultMessage="Event Code : To" /></InputLabel>
                </ThemeProvider>
                <Select
                    id="eventCodeTo"
                    variant='filled'
                    labelId='eventCodeTo'
                    value={defaultEventCodeToValue}
                    onChange={props.handleEventCodeFrom}
                    MenuProps={{ disableScrollLock: false }}
                >
                    {props.options.map((option, index) => {
                        return (
                            <MenuItem key={index} value={option.vehEventCodes}>
                                {/* {option.vehEventCodes.split(' / ')[0]} / <FormattedMessage
                                    id={`eventcode.${option.vehEventCodes.split(' ')[0]}`}
                                    defaultMessage={option.vehEventCodes} /> */}

                                {option.vehEventCodes} / <FormattedMessage
                                    id={`eventcode.${option.vehEventCodes}`}
                                    defaultMessage={option.vehEventCodes} />


                                {/* {option.vehEventCodes} */}

                            </MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </>
    )
}

export function RecordsToReturn(props) {
    let defaultRecordsToReturnValue;
    if (props.value === '') {
        defaultRecordsToReturnValue = props.defaultRecordsToReturn
    }
    else {
        defaultRecordsToReturnValue = props.value
    }

    return (
        <>
            <FormControl variant='filled' sx={styles.advancedSearchSelect}>
                <ThemeProvider theme={theme}>
                    <InputLabel><FormattedMessage id="advancedsearchcomponents.recordstoreturn" defaultMessage="Records To Return" /></InputLabel>
                </ThemeProvider>
                <Select
                    id="recordsToReturn"
                    variant='filled'
                    labelId='recordsToReturn'
                    value={defaultRecordsToReturnValue}
                    onChange={props.onChange}
                    MenuProps={{ disableScrollLock: false }}
                >
                    {props.options.map(option => {
                        return (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </>
    )
}

export function AdvancedSearchClearButton(props) {
    return (
        <>
            <Button id="clearButton" sx={styles.orderSummaryClear} onClick={props.onChange} >
                <FormattedMessage id='ordersummarycomponents.clear' defaultMessage='Clear' />
            </Button>
        </>
    )
}

export function AdvancedSearchSearchButton() {
    return (
        <>
            <Button id="searchButton" sx={styles.orderSummarySearch} ><FormattedMessage id='ordersummarycomponents.search' defaultMessage='Search' /></Button>
        </>
    )
}
